<template>
  <div class="container orders-view">
    <!-- 面包屑 -->
    <OrderList @choosed="toDetail" @action="goIndex"></OrderList>
  </div>
</template>

<script type="text/javascript">
import OrderList from '@/core/order-list/order-list';

export default {
  components: {
    OrderList
  },
  methods: {
    toDetail (orderId) {
      this.$router.push({name: 'OrderItem', params: {orderId}});
    },

    goIndex () {
      if (window === window.top) {
        this.$router.push('/');
        return;
      }

      window.top.location = 'https://shop.nubia.com/recycle.php';
    }
  }
};
</script>

<style scoped>
.order-list-wrap {
  margin-top: 24px;
}
</style>
